export const API_GATEWAY_DEFAULT_SUBDOMAIN = 'api'
export const API_GATEWAY_EDGE_SUBDOMAIN = 'edge.api'
export const API_GATEWAY_TRANSPARENT_PROXY_PATH = '/web/gateway'
export const PLATFORM_HEADER_KEY = 'Platform'
export const LOCALE_HEADER_KEY = 'Locale'

export enum ApiGatewayType {
  Default = 'default',
  Edge = 'edge',
}
